/*eslint-disable*/
export const messages = {
  // System notices (truncation / safety refusal)
  "This answer was shortened because it reached the length limit and may be incomplete.": "Cette réponse a été raccourcie car elle a atteint la limite de longueur et peut être incomplète.",
  "This request can't be answered due to safety guidelines. Please rephrase or ask about a different topic.": "Cette demande ne peut pas être traitée pour des raisons de sécurité. Veuillez la reformuler ou poser une question sur un autre sujet.",
  "Cancel": "Annuler",
  "Change theme": "Changer de thème",
  "Clear chat": "Effacer la conversation",
  "Clear chat history": "Effacer l'historique de conversation",
  "Connecting...": "Connexion en cours...",
  "Continue": "Continuer",
  "Decrease font size": "Réduire la taille de police",
  "Disclaimer": "Avertissement",
  "Enter your message...": "Saisissez votre message...",
  "Type your message...": "Saisissez votre message...",
  "Error": "Erreur",
  "Font size": "Taille de police",
  "Increase font size": "Augmenter la taille de police",
  "Language": "Langue",
  "MJ Lab": "Laboratoire MJ",
  "Reset font size": "Réinitialiser la taille de police",
  "Respond time: {time}s": "Temps de réponse : {time}s",
  "Response time:": "Temps de réponse :",
  "Send": "Envoyer",
  "Settings": "Paramètres",
  "Support the project": "Soutenir le projet",
  "System": "Système",
  "Theme": "Thème",
  "Thinking...": "Réflexion en cours...",
  "Toggle theme": "Basculer le thème",
  "Welcome to {{name}} by MJ": "Bienvenue sur {{name}} par MJ",
  "You asked:": "Vous avez demandé :",
  
  // Headers
  "Ministry of Commerce Laws Expert": "Expert en lois du MoC",
  "by MJ": "par MJ",
  "Hello, I am {{name}}, an AI assistant made by MJ.": "Bonjour, je suis {{name}}, un assistant IA créé par MJ.",
  "I am expert in Ministry of Commerce laws and regulations for Saudi Arabia.": "Je suis expert en lois et réglementations du Ministère du Commerce de l'Arabie Saoudite.",
  "Ask me a question, and I will gladly answer you.": "Posez-moi une question, et je vous répondrai avec plaisir.",
  "Do not share confidential data.": "Ne partagez pas de données confidentielles.",
  "I am powered using": "Je suis propulsé par",
  
  // Disclaimer
  "Disclaimer: {{name}} is an experimental AI assistant designed to respond using data from Saudi Ministry of Commerce laws and regulations, avoiding assumptions or inaccuracies. I am not responsible for its behavior or the correctness of its responses.": "**Avertissement :** {{name}} est un assistant IA expérimental conçu pour répondre en utilisant des données issues des lois et réglementations du Ministère du Commerce saoudien, évitant les suppositions ou inexactitudes. Je ne suis pas responsable de son comportement ou de l'exactitude de ses réponses.",
  
  // Frameworks
  "Automatic detection": "Détection automatique",
  
  // A. Business Formation and Identity
  "MOC_COMPANIES_LAW": "A1. Loi sur les sociétés du MC",
  "MOC_PROFESSIONAL_COMPANIES_LAW": "A2. Loi sur les sociétés professionnelles du MC",
  "MOC_COMMERCIAL_REGISTER_LAW": "A3. Loi sur le registre du commerce du MC",
  "MOC_MINISTRY_OF_COMMERCE_LAW": "A4. Loi sur le Ministère du Commerce",
  "MOC_TRADE_NAMES_LAW": "A5. Loi sur les noms commerciaux du MC",
  "MOC_GCC_TRADEMARK_LAW": "A6. Loi sur les marques du CCG",
  
  // B. Financial Instruments, Security, and Insolvency
  "MOC_COMMERCIAL_PAPERS_LAW": "B1. Loi sur les effets de commerce du MC",
  "MOC_COMMERCIAL_PLEDGE_LAW": "B2. Loi sur le nantissement commercial du MC",
  "MOC_MOVABLE_PROPERTY_SECURITY_LAW": "B3. Loi sur les sûretés mobilières du MC",
  "MOC_INSOLVENCY_LAW": "B4. Loi sur l'insolvabilité du MC",
  
  // C. Commercial Relationships and Trade
  "MOC_COMMERCIAL_AGENCIES_LAW": "C1. Loi sur les agences commerciales du MC",
  "MOC_FRANCHISE_LAW": "C2. Loi sur les franchises du MC",
  "MOC_ECOMMERCE_LAW": "C3. Loi sur le commerce électronique du MC",
  "MOC_CHAMBERS_OF_COMMERCE_LAW": "C4. Loi sur les chambres de commerce du MC",
  
  // D. Commercial Records and Information
  "MOC_COMMERCIAL_BOOKS_LAW": "D1. Loi sur les livres de commerce du MC",
  "MOC_COMMERCIAL_DATA_LAW": "D2. Loi sur les données commerciales du MC",
  "MOC_PUBLIC_WAREHOUSING_LAW": "D3. Loi sur l'entreposage public du MC",
  
  // E. Standards, Quality, and Regulated Products
  "MOC_STANDARDS_METROLOGY_LAW": "E1. Loi sur les normes et la métrologie du MC",
  "MOC_CALIBRATION_MEASUREMENT_LAW": "E2. Loi sur l'étalonnage et la mesure du MC",
  "MOC_PRIVATE_LABORATORIES_LAW": "E3. Loi sur les laboratoires privés du MC",
  "MOC_PRECIOUS_METALS_GEMSTONES_LAW": "E4. Loi sur les métaux précieux et pierres gemmes du MC",
  "MOC_CHEMICALS_IMPORT_MANAGEMENT_LAW": "E5. Loi sur la gestion de l'importation des produits chimiques du MC",
  
  // F. Professional Regulation and Oversight
  "MOC_ACCOUNTING_AUDITING_LAW": "F1. Loi sur la comptabilité et l'audit du MC",
  "MOC_VALUERS_LAW": "F2. Loi sur les évaluateurs du MC",
  "MOC_ENGINEERS_LAW": "F3. Loi sur les ingénieurs du MC",
  
  // G. Compliance and Dispute Resolution
  "MOC_ANTI_CONCEALMENT_LAW": "G1. Loi anti-dissimulation du MC",
  "MOC_ANTI_MONEY_LAUNDERING_LAW": "G2. Loi contre le blanchiment d'argent du MC",
  "MOC_ARBITRATION_LAW": "G3. Loi sur l'arbitrage du MC",
  "MOC_COMBATING_COMMERCIAL_ADULTERATION_LAW": "G4. Loi contre la falsification commerciale du MC",
  "MOC_GCC_COMBATING_DUMPING_LAW": "G5. Loi contre le dumping du CCG",
  
  // Models
  "Claude by Anthropic": "Claude par Anthropic",
  "DeepSeek by Groq": "DeepSeek par Groq",
  "MJ Lab Mode": "Mode Laboratoire MJ",
  
  // Character count
  "{{remainingChars}} character left": "{{remainingChars}} caractère restant",
  "{{remainingChars}} characters left": "{{remainingChars}} caractères restants",
  
  // Error messages
  "An error occurred": "Une erreur s'est produite",
  "Failed to change language": "Échec du changement de langue",
  "Please try again": "Veuillez réessayer",
  "Connection lost": "Connexion perdue",
  "Reconnecting...": "Reconnexion en cours...",
  "Nothing to clear": "Rien à effacer",
  "All messages cleared": "Tous les messages ont été effacés",
  "All data cleared": "Toutes les données ont été effacées",
  "Storage limit reached": "Limite de stockage atteinte",
  "Some older messages were removed to save space.": "Certains messages plus anciens ont été supprimés pour économiser de l'espace.",
  
  // Additional keys
  "Font Size": "Taille de police",
  "Language changed to {locale}": "Langue changée en {locale}",
  "Select language": "Sélectionner la langue",
  "Support": "Support",
  
  // Brand names (do not translate)
  "Mila": "Mila",
  
  // Message actions
  "Message copied to clipboard": "Message copié dans le presse-papiers",
  "Read": "Lire",
  "Summarize": "Résumer",
  
  // Ice Breakers Dialog
  "Message Suggestions": "Suggestions de messages",
  "Select a question to quickly start a conversation about Saudi Ministry of Commerce laws.": "Sélectionnez une question pour démarrer rapidement une conversation sur les lois du Ministère du Commerce saoudien.",
  "What are the main requirements under the Companies Law for establishing a limited liability company in Saudi Arabia?": "Quelles sont les principales exigences selon la Loi sur les sociétés pour établir une société à responsabilité limitée en Arabie Saoudite ?",
  "How does the Commercial Agencies Law regulate relationships between foreign companies and Saudi agents?": "Comment la Loi sur les agences commerciales régule-t-elle les relations entre les entreprises étrangères et les agents saoudiens ?",
  "What protections does the Saudi E-commerce Law provide for online consumers and businesses?": "Quelles protections la Loi saoudienne sur le commerce électronique offre-t-elle aux consommateurs et aux entreprises en ligne ?",
  
  // Audio Player Dialog
  "AI Summary": "Résumé IA",
  "Listen to the summarized response using our AI Service.": "Écoutez la réponse résumée grâce à notre service d'IA.",
  "Generating summary...": "Génération du résumé...",
  "Preparing audio...": "Préparation de l'audio...",
  
  // Audio Player Error Messages
  "Failed to process text. Please try again.": "Échec du traitement du texte. Veuillez réessayer.",
  "Failed to auto-play audio. Click play to try again.": "Échec de la lecture automatique de l'audio. Cliquez sur lecture pour réessayer.",
  "Failed to load audio. Please try again.": "Échec du chargement de l'audio. Veuillez réessayer.",
  "Audio playback was aborted.": "La lecture audio a été interrompue.",
  "Network error occurred while loading audio.": "Une erreur réseau s'est produite lors du chargement de l'audio.",
  "Audio decoding failed.": "Échec du décodage audio.",
  "Audio format not supported.": "Format audio non pris en charge.",
  "Failed to setup audio playback": "Échec de la configuration de la lecture audio",
  "Failed to generate speech": "Échec de la génération de la parole",
  "Failed to generate audio. Please try again.": "Échec de la génération audio. Veuillez réessayer.",
  "Failed to play audio. Please try again.": "Échec de la lecture audio. Veuillez réessayer."
};